export const FIREBASE_CONFIG = Object.freeze({
    apiKey: 'AIzaSyCB9X-_vQhjWZdX0HKbol_UTCV7iMUCkZE',
    authDomain: 'dpn-staging-7ca59.firebaseapp.com',
    databaseURL: 'https://dpn-staging-7ca59.firebaseio.com',
    projectId: 'dpn-staging-7ca59',
    storageBucket: 'dpn-staging-7ca59.appspot.com',
    messagingSenderId: '674587765180',
    appId: '1:674587765180:web:3f56eeb2a91c0f2de823b9'
})